/*=============================================== LangSelect component ===============================================*/

import { useContext, useState, useRef } from "react"
import classNames from "classnames"
import { Icon, ThemeContext, useClickOutside } from "tsx-library-julseb"
import type { ThemeContextProps } from "tsx-library-julseb/types"

import { LangContext } from "context"
import type { LangContextType, LanguageTypes } from "context"

import { StyledLangSelect, Button, List, Item } from "./styles"

const LangSelect = () => {
    const { language, handleChangeLang } = useContext(
        LangContext
    ) as LangContextType
    const { selectedTheme } = useContext(ThemeContext) as ThemeContextProps

    const [isOpen, setIsOpen] = useState(false)
    const el = useRef<HTMLDivElement>(null)
    useClickOutside(el, () => setIsOpen(false))

    const handleClick = (lang: LanguageTypes) => {
        handleChangeLang(lang)
        setIsOpen(false)
    }

    return (
        <StyledLangSelect ref={el}>
            <Button
                data-theme={selectedTheme}
                onClick={() => setIsOpen(!isOpen)}
            >
                {language?.toUpperCase()}

                <Icon src="caret-down" size={16} />
            </Button>

            <List className={classNames({ open: isOpen })}>
                <Item
                    onClick={() => handleClick("js")}
                    className={classNames({ active: language === "js" })}
                >
                    JS
                </Item>
                <Item
                    onClick={() => handleClick("ts")}
                    className={classNames({ active: language === "ts" })}
                >
                    TS
                </Item>
            </List>
        </StyledLangSelect>
    )
}

export default LangSelect
